
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Bestcabserviceinpune() {



    const cardData =
    {
        keyword: 'Best Cab Service in Pune  ',
        heading: 'Morya Cabs:  Best Cab Service in Pune  ',
        headingDescription: 'Looking for the best cab service in Pune? Morya Cabs offers reliable, affordable, and comfortable taxi services for all your travel needs. Whether you require a cab for airport transfers, local city rides, outstation trips, corporate travel, or weekend getaways, we provide well-maintained vehicles with professional drivers to ensure a safe and hassle-free journey. Book your cab online and enjoy a smooth ride at competitive rates.',

        top: 'Top Places to Visit in Pune with Morya Cabs',

        topPlaces: [
            {
                "title": "Shaniwar Wada",
                "description": "A historic landmark, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. The fort’s grand architecture, intricate wooden carvings, and rich history attract tourists and history buffs. With Morya Cabs, you can explore this heritage site comfortably and at your own pace."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "A renowned temple in Pune, Dagdusheth Ganpati is visited by thousands of devotees every year. Known for its beautifully adorned idol of Lord Ganesha, the temple is a must-visit for spiritual seekers. Morya Cabs ensures a hassle-free journey to this sacred destination."
            },
            {
                "title": "Sinhagad Fort",
                "description": "For adventure lovers, Sinhagad Fort is an ideal destination for trekking and sightseeing. The fort offers breathtaking views of Pune’s landscape, and the historical significance adds to its charm. Book a Pune cab with Morya Cabs to enjoy a scenic drive to this magnificent fort."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Built in 1892, Aga Khan Palace is a symbol of India’s freedom struggle. This beautiful structure served as a prison for Mahatma Gandhi and his wife during the independence movement. Morya Cabs provides a smooth and comfortable ride to this historically significant site."
            },
            {
                "title": "Rajiv Gandhi Zoological Park",
                "description": "A favorite among families and wildlife enthusiasts, Rajiv Gandhi Zoo houses a variety of animals, reptiles, and birds. It’s an excellent place for kids and nature lovers. Book a cab with Morya Cabs and enjoy a day out with your loved ones."
            },
            {
                "title": "Osho International Meditation Resort",
                "description": "Located in Koregaon Park, the Osho Ashram is a serene place for meditation and self-discovery. It attracts visitors from all over the world seeking peace and spiritual growth. With Morya Cabs, you can travel conveniently to this peaceful retreat."
            },
            {
                "title": "Pu La Deshpande Garden (Pune Okayama Friendship Garden)",
                "description": "Inspired by Japanese gardens, Pu La Deshpande Garden offers a tranquil and picturesque escape from city life. The beautifully landscaped garden is ideal for nature walks and photography. Morya Cabs ensures a smooth ride to this relaxing destination."
            },
            {
                "title": "Pashan Lake",
                "description": "A scenic lake perfect for nature lovers and birdwatchers, Pashan Lake is a serene getaway within the city. Enjoy the peaceful atmosphere and spot migratory birds with a convenient cab ride from Morya Cabs."
            },
            {
                "title": "Lavasa City",
                "description": "A short drive from Pune, Lavasa is a stunning hill city designed in European style. The lakeside promenade, adventure activities, and scenic surroundings make it a perfect weekend getaway. Travel to Lavasa in comfort with Morya Cabs."
            },
            {
                "title": "Lonavala & Khandala",
                "description": "Known for their lush green hills, waterfalls, and misty weather, Lonavala and Khandala are popular hill stations near Pune. Whether you're planning a one-day trip or a weekend stay, Morya Cabs provides the best taxi services to these scenic destinations."
            }
        ],



"services": [
    {
        "name": "Reliable Cab Service Pune",
        "description": "Morya Cab offers reliable cab service in Pune, ensuring you get to your destination comfortably and on time. With our dedicated team and professional drivers, you can count on us for a seamless ride every time."
    },
    {
        "name": "Affordable Best Cabs in Pune",
        "description": "Looking for affordable best cabs in Pune? Morya Cab provides top-notch service at competitive prices. We ensure that you get the best value for your money, without compromising on comfort or quality."
    },
    {
        "name": "Luxury Cab Service Pune",
        "description": "For those who seek elegance and comfort, Morya Cab offers luxury cab service in Pune. Enjoy a premium experience with high-end vehicles and professional chauffeurs dedicated to making your ride exceptional."
    },
    {
        "name": "Pune Best Car Service",
        "description": "Morya Cab is known for providing Pune’s best car service, offering a range of vehicles for every type of journey. Whether you need a compact car for a city trip or a spacious vehicle for a long-distance journey, we have the perfect option for you."
    },
    {
        "name": "Highly Rated Cab Service Pune",
        "description": "Experience highly rated cab service in Pune with Morya Cab. We take pride in providing exceptional service, and our satisfied customers speak to the quality of our rides and the professionalism of our drivers."
    },
    {
        "name": "Pune Best Taxi Booking",
        "description": "When you need the best taxi booking service in Pune, Morya Cab is the right choice. Our easy-to-use platform ensures that you can quickly reserve a cab for any occasion, whether it’s for a short ride or an outstation trip."
    },
    {
        "name": "Top-Rated Cab Service Pune",
        "description": "Choose Morya Cab for a top-rated cab service in Pune. With our commitment to reliability, punctuality, and comfort, we’ve earned our place as one of the most trusted cab services in the city."
    },
    {
        "name": "Pune Elite Taxi Service",
        "description": "For those looking for elite taxi service in Pune, Morya Cab provides high-quality rides with extra attention to detail. We offer luxury vehicles and a premium experience for all types of travelers."
    },
    {
        "name": "Best 24/7 Cab Service Pune",
        "description": "Morya Cab offers best 24/7 cab service in Pune, so you can rely on us anytime you need a ride. Whether it’s early morning or late at night, we’re always available to get you where you need to go."
    },
    {
        "name": "Pune Premium Taxi Service",
        "description": "For a top-class travel experience, try our Pune premium taxi service. With high-end vehicles and skilled drivers, Morya Cab guarantees a smooth and luxurious ride every time."
    },
    {
        "name": "Best Pune Taxi Providers",
        "description": "Morya Cab is one of the best Pune taxi providers, offering reliable and affordable taxi services to customers across the city. Whether you need a ride for a short trip or a long journey, we are ready to serve you."
    },
    {
        "name": "Recommended Cab Service Pune",
        "description": "Morya Cab is a recommended cab service in Pune, trusted by locals and tourists alike for its high standards and exceptional service. We ensure that your journey is comfortable, safe, and affordable."
    },
    {
        "name": "Best Cab Service in Pune",
        "description": "Looking for the best cab service in Pune? Look no further than Morya Cab. We offer the highest quality of service, with a wide range of vehicles and experienced drivers to meet all your transportation needs."
    },
    {
        "name": "Best Cab Service Pune to Mumbai",
        "description": "Morya Cab provides the best cab service from Pune to Mumbai, ensuring a comfortable and safe journey. Book your ride today and travel in style with our professional drivers and well-maintained vehicles."
    },
    {
        "name": "Best Outstation Cab Service in Pune",
        "description": "Planning an outstation trip? Morya Cab offers the best outstation cab service in Pune, providing reliable, comfortable, and cost-effective rides for all your long-distance travel needs."
    },
    {
        "name": "Best Taxi Service in Pune",
        "description": "For the best taxi service in Pune, Morya Cab is your go-to provider. Whether you need a ride for business or leisure, we offer punctual, comfortable, and affordable taxi services across Pune."
    },
    {
        "name": "Best Cab Service Mumbai to Pune",
        "description": "Traveling from Mumbai to Pune? Morya Cab provides the best cab service Mumbai to Pune, offering a smooth, relaxing ride with experienced drivers who know the best routes for your journey."
    },
    {
        "name": "Best Cab Service from Mumbai Airport to Pune",
        "description": "When you need a ride from Mumbai Airport to Pune, Morya Cab offers the best cab service for this route. Our experienced drivers will ensure you have a timely, safe, and comfortable ride to your destination."
    },
    {
        "name": "Best Cab Service from Pune to Goa",
        "description": "For your trip to Goa, Morya Cab offers the best cab service from Pune to Goa. Whether you’re traveling for leisure or business, enjoy a scenic, safe, and comfortable ride with our professional drivers."
    },
    {
        "name": "Best Cab Service from Pune to Mumbai Airport",
        "description": "Need a ride from Pune to Mumbai Airport? Morya Cab offers the best cab service for airport transfers, ensuring you arrive at the airport on time, stress-free, and in comfort."
    },
    {
        "name": "Best Mumbai Pune Cab Service",
        "description": "When traveling from Mumbai to Pune, Morya Cab offers the best Mumbai Pune cab service. Enjoy a premium experience with our well-maintained vehicles and professional drivers, ensuring your journey is seamless and stress-free."
    },
    {
        "name": "Best Pune to Mumbai Cab Service",
        "description": "For the best Pune to Mumbai cab service, Morya Cab provides reliable, safe, and affordable rides. Travel comfortably and reach your destination on time with our expert drivers."
    }
],



tableData: [
    ["Reliable Cab Service Pune", "-Affordable Best Cabs in Pune"],
    ["Luxury Cab Service Pune", "-Pune Best Car Service"],
    ["Highly Rated Cab Service Pune", "-Pune Best Taxi Booking"],
    ["Top-Rated Cab Service Pune", "-Pune Elite Taxi Service"],
    ["Best 24/7 Cab Service Pune", "-Pune Premium Taxi Service"],
    ["Best Pune Taxi Providers", "-Recommended Cab Service Pune"],
    ["Best cab service in Pune", "-Best Cab Service Pune to Mumbai"],
    ["Best Outstation Cab Service in Pune", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we believe in providing punctual and dependable service. Whether it's a ride for a business meeting, airport transfer, or a simple city trip, our drivers ensure you reach your destination on time, every time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a fleet of well-maintained vehicles, including sedans, SUVs, and premium cars, designed to provide maximum comfort and space for both short and long journeys in Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are professional, well-trained, and familiar with all routes across Pune. They ensure a safe, smooth, and hassle-free journey, keeping your comfort and safety a top priority."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer the best fares in the market, without hidden charges. Morya Cab ensures complete transparency in pricing, with a detailed breakdown of your fare before the journey, giving you peace of mind."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our utmost priority. All our vehicles are equipped with modern safety features, including seat belts, airbags, and GPS tracking. Rest assured, you're in good hands with Morya Cab."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you need a ride early in the morning or late at night, Morya Cab is available around the clock to serve you. Our customer support team is always ready to assist you whenever needed."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your cab with Morya Cab is easy and convenient! You can book a ride online through our website or app or simply call our customer service for any assistance. It's a stress-free process from start to finish."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Morya Cab offers tailored travel solutions, whether you're visiting Pune for business, sightseeing, or a special event. Let us know your requirements, and we'll create a package that fits your needs perfectly."
    }
]











    }

    const faqData = [
        {
          question: "How can I book a cab with Morya Cab in Pune?",
          answer: "You can book a cab easily via our website, mobile app, or by contacting our customer support team for any specific requirements."
        },
        {
          question: "Are the drivers experienced for local travel in Pune?",
          answer: "Yes, all our drivers are highly experienced and well-acquainted with Pune’s local roads, ensuring a smooth and efficient ride."
        },
        {
          question: "What types of vehicles are available for booking?",
          answer: "We offer a variety of vehicles including sedans, SUVs, and premium cars, all well-maintained and equipped with comfortable seating for your journey."
        },
        {
          question: "How do I pay for my Pune cab?",
          answer: "We accept multiple payment methods including cash, credit/debit cards, and online payments through our mobile app for your convenience."
        },
        {
          question: "Can I book a round trip in Pune?",
          answer: "Yes, you can easily book a round trip. Just provide your return details at the time of booking, and we'll take care of the rest."
        },
        {
          question: "Are there extra charges for waiting or detours?",
          answer: "If there are any extra charges, such as waiting time or detours, these will be clearly communicated upfront so you can plan your trip accordingly."
        },
        {
          question: "Can I hire a cab for sightseeing in Pune?",
          answer: "Absolutely! Morya Cab offers sightseeing tours to explore Pune’s best attractions like Shaniwar Wada, Aga Khan Palace, and more. Just let us know your preferences."
        },
        {
          question: "What is the luggage allowance for a cab in Pune?",
          answer: "Our vehicles can comfortably accommodate standard luggage. If you have special luggage needs, please inform us during the booking process, and we’ll make the necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel in Pune?",
          answer: "Yes, Morya Cab offers corporate travel services including rides for business meetings, corporate events, and group transportation."
        },
        {
          question: "Why should I choose Morya Cab for my Pune trip?",
          answer: "Morya Cab provides the best cab service in Pune, ensuring you have a safe, comfortable, and affordable journey. Our experienced drivers, modern vehicles, and excellent customer service guarantee a smooth experience."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Sanjay Patel',
          role: 'Business Traveller',
          review: 'I had an excellent experience with Morya Cab on my business trip in Pune. The driver was professional, the vehicle was clean, and I arrived on time without any hassle. I will definitely use them again.',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Kavita Rao',
          role: 'Sightseer',
          review: 'Our family hired Morya Cab for a sightseeing tour in Pune. The car was comfortable, and the driver was friendly and knowledgeable. We had a wonderful experience, and I highly recommend this service!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "Best Cab Service in Pune",
        "description": "Experience reliable, affordable, and luxury cab services in Pune. We provide top-rated taxi services, including outstation rides, airport transfers, and premium travel options for destinations like Mumbai, Goa, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, First Floor, Sunshine Complex, Near ABC Chowk, Pune",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-9371304510",
        "url": "https://moryacab.com/best-cab-service-in-pune",
        "logo": "https://moryacab.com/img/logo.jpg",
        "image": [
          "https://moryacab.com/img/best-cab-service-pune.jpg",
          "https://moryacab.com/img/pune-premium-taxi-service.jpg"
        ],
        "priceRange": "₹2000 - ₹6000",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/best-cab-service-in-pune",
          "priceCurrency": "INR",
          "price": 3000,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.9,
          "reviewCount": 450
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Shreya Joshi"
            },
            "datePublished": "2024-10-20",
            "reviewBody": "The Best Cab Service in Pune truly lives up to its name. The car was clean, the driver was friendly and punctual. I had an amazing experience traveling from Pune to Mumbai. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikas Patil"
            },
            "datePublished": "2024-08-25",
            "reviewBody": "This is the most reliable and luxury cab service I’ve used in Pune. Their service from Pune to Goa was seamless and comfortable. Worth every penny!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Best Cab Service Pune Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 18.5204,
            "longitude": 73.8567
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/best-cab-service-in-pune"
        },
        "keywords": "Reliable Cab Service Pune, Affordable Best Cabs in Pune, Luxury Cab Service Pune, Pune Best Car Service, Highly Rated Cab Service Pune, Pune Best Taxi Booking, Top-Rated Cab Service Pune, Pune Elite Taxi Service, Best 24/7 Cab Service Pune, Pune Premium Taxi Service, Best Pune Taxi Providers, Recommended Cab Service Pune, Best cab service in Pune, Best Cab Service Pune to Mumbai, Best Outstation Cab Service in Pune, Best Taxi Service in Pune, Best cab service Mumbai to Pune, Best cab service from Mumbai airport to Pune, Best Cab Service from Pune to Goa, Best Cab Service from Pune to Mumbai Airport, Best Mumbai Pune cab service, Best Pune to Mumbai cab service"
      };
      

    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Best Cab Service in Pune | Reliable & Luxury Cabs | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Experience the best and most reliable cab service in Pune. We offer affordable, luxury, and top-rated taxi services, including outstation rides and airport transfers."
  />
  <meta
    name="keywords"
    content="Reliable Cab Service Pune, Affordable Best Cabs in Pune, Luxury Cab Service Pune, Pune Best Car Service, Highly Rated Cab Service Pune, Pune Best Taxi Booking, Top-Rated Cab Service Pune, Pune Elite Taxi Service, Best 24/7 Cab Service Pune, Pune Premium Taxi Service, Best Pune Taxi Providers, Recommended Cab Service Pune, Best cab service in Pune, Best Cab Service Pune to Mumbai, Best Outstation Cab Service in Pune, Best Taxi Service in Pune, Best cab service Mumbai to Pune, Best cab service from Mumbai airport to Pune, Best Cab Service from Pune to Goa, Best Cab Service from Pune to Mumbai Airport, Best Mumbai Pune cab service, Best Pune to Mumbai cab service"
  />
  <meta property="og:title" content="Best Cab Service in Pune | Morya Cabs" />
  <meta
    property="og:description"
    content="Experience reliable and luxury cab services in Pune. We offer affordable rides to Mumbai, Goa, airport transfers, and more. Book now for a premium experience."
  />
  <meta property="og:url" content="https://moryacab.com/best-cab-service-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://moryacab.com/img/best-cab-service-pune.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Bestcabserviceinpune;